export interface IRexmItem {
    swapIndex: number,
    chainIndex: number,
    pathIndex: number,
    oneWayId: number
}